import {
    IPromotionalCardProperties,
    PromotionalCard,
} from '@vfde-brix/ws10/promotional-card';
import { getCMSConfig } from '../cms';
import { formatPrice } from '../formatter';
import { updateCashbackPromotionCard } from '../../components/promotionalCard';
import { State } from 'Container/App/selector';
import { setElementVisibility } from '../visibility';
import {
    DiscountId,
    HtmlId,
} from '../../enums/elementId';
import { getCookie } from '@vfde-sails/utils';
import {
    Cookies,
    Namespace,
} from '../../enum';
import { mountFootnoteLink } from '../../components/footnoteLink';
const windowObj = window as any;

/**
 * Gets the props that need to be
 * updated for the resident card
 * FIXME
 */
export const getResidentCardProps = (
    price: number | string,
): Partial<IPromotionalCardProperties> => {
    const { label, subLabel } = getCMSConfig().residentPlusCard;

    return {
        stdLabel: formatPrice(label, Math.abs(+price)),
        txtSublabel: formatPrice(subLabel, Math.abs(+price)),
    };
};

/**
 * setup Scroll To Target
 */
export const setupScrollToTarget = (linkId: HtmlId, targetId: HtmlId) => {
    const linkElement = document.getElementById(linkId);

    if (!linkElement) {
        return;
    }

    linkElement.addEventListener('click', event => {
        event.preventDefault();
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
            targetElement.scrollIntoView({ behavior: 'smooth' });
        }
    });
};

/**
 * update PS Promo Visibility based on isPlaystationPromo
 */
export const updatePromoVisibility = (isPlaystationPromo: boolean) => {
    setElementVisibility(DiscountId.PLAYSTATION_PROMO_CARD, isPlaystationPromo);
    setElementVisibility(DiscountId.PS_BANNER, isPlaystationPromo);
};

/**
 * open avc overlay
 */
export const addAVCOpenActionCashbackCard = (onClick: any) => {
    const upsellingLink = document.getElementById(DiscountId.UPSELL_LINK);

    if (upsellingLink && upsellingLink.parentNode) {
        // Remove any existing event listeners to avoid multiple triggers
        const newElement = upsellingLink?.cloneNode(true);
        upsellingLink?.parentNode?.replaceChild(newElement, upsellingLink);

        newElement.addEventListener('click', event => {
            event.preventDefault();
            event.stopPropagation();
            onClick(true, Namespace.AVC);
        });
    }
};

/**
 * openTealiumOverlay
 * call this function when we relad tha page and we have address cookies and no tealium cookies to be able to get the checkbox element
 */
export const openTealiumOverlay = () => {
    if (typeof windowObj.adv_lib !== 'undefined' && typeof windowObj.adv_lib.cashback !== 'undefined') {
        setTimeout(() => {
            windowObj.adv_lib.cashback.start.cashback_flow_promotional_card();
        }, 1000);
    }
};

/**
 * fn to updateCashbackCard
 *
 * @param state
 * @param promotionCard
 * @returns
 */
export const updateCashbackCard = (state: State, promotionCard: PromotionalCard | null, onClick: any, isPlaystationPromo: boolean) => {
    const cashbackCard = getCMSConfig().cashbackModule;

    if (isPlaystationPromo) {
        setElementVisibility(DiscountId.CASH_BACK, false);
        setElementVisibility(DiscountId.CASH_BACK_DISABLED, false);

        return null;
    }

    if (!cashbackCard) {
        return null;
    }

    if (state.isLoggedInCableCustomer) {
        setElementVisibility(DiscountId.CASH_BACK, false);
        setElementVisibility(DiscountId.CASH_BACK_DISABLED, false);

        return null;
    }

    if (getCookie(Cookies.TELLJA)) {
        if (!isPlaystationPromo) {
            setElementVisibility(DiscountId.CASH_BACK_DISABLED, false);
            setElementVisibility(DiscountId.CASH_BACK, true);
        }

        updateCashbackPromotionCard(promotionCard, cashbackCard.telljaCookieExist, true, true);

        return true;
    }

    if (state?.address && getCookie(Cookies.ADDRESS) && !state.isContentEnabled) {
        setElementVisibility(DiscountId.CASH_BACK, false);
        setElementVisibility(DiscountId.CASH_BACK_DISABLED, true);

        return true;
    }

    if (state?.address && getCookie(Cookies.ADDRESS)) {
        openTealiumOverlay();
        updateCashbackPromotionCard(promotionCard, cashbackCard.afterAvailabilityCheck, !state.isContentEnabled);
        addAVCOpenActionCashbackCard(onClick);
    }

    if (!state?.address && !getCookie(Cookies.ADDRESS) && !getCookie(Cookies.TELLJA)) {
        updateCashbackPromotionCard(promotionCard, cashbackCard.default);
        addAVCOpenActionCashbackCard(onClick);
    }

    setElementVisibility(DiscountId.CASH_BACK_DISABLED, false);
    setElementVisibility(DiscountId.CASH_BACK, true);

    return null;
};

/**
 * createSailsReadyEventcashBack
 * we removed createSailsReadyEvent temporary from utils untill we align with tealuim team about the chages done in the utils repos
 *
 * @param actions
 * @param applicationScope
 */
export const createSailsReadyEventcashBack = (actions: Record<string, CallableFunction>, applicationScope: string | null = null): void => {
    const event = new Event('sails:ready');
    createPublicFunctioncashBack(actions, applicationScope);

    document.dispatchEvent(event);
};

/**
 * createPublicFunctioncashBack
 * create publick event to be used outside the app
 *
 * @param actions
 * @param applicationScope
 */
export const createPublicFunctioncashBack = (actions: Record<string, CallableFunction>, applicationScope: string | null = null): void => {
    const { VF = {} } = (window as any);
    const { SAILS = {} } = VF;

    (window as any).VF = VF;

    (window as any).VF.SAILS = SAILS;

    (window as any).VF.SAILS = {
        ...(window as any).VF.SAILS,
        ...applicationScope && ({ [applicationScope]: {
            ...(window as any).VF.SAILS[applicationScope],
            ...actions,
        } }),
        ...!applicationScope && (actions),
    };
};

/**
 * registerPublicevent
 * register a public event to be used by tealium side so that after closing the overly form of tealium then we can
 * use the promotional brix component to update the state of the checkbox and text
 *
 * @param promotionCard
 */
export const registerPublicevent = (promotionCard: PromotionalCard) => {
    const cashbackCard = getCMSConfig().cashbackModule;

    // if not cashback return
    if (!cashbackCard) {
        return;
    }

    const actionConfigurations: any =
        {
            actions: {
                updateCashbackPromotionCard: () => {
                    updateCashbackPromotionCard(promotionCard, cashbackCard.telljaCookieExist, true, true);
                },
                updateFootNote: () => {
                    mountFootnoteLink(DiscountId.CASH_BACK);
                },
                applicationScope: 'tealiumCashback',
            },
        };
    createSailsReadyEventcashBack(actionConfigurations);
};
